"use strict";
// Option-reading helpers for SINGLE_SELECT-style displays.
//
// SINGLE_SELECT options live under one of three sibling keys depending
// on the chosen presentation (text / radio / image). Callers shouldn't
// need to know which — this helper walks them in priority order so
// every plugin's renderer + the web client agree on what an option is.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSingleSelectOptions = getSingleSelectOptions;
function getSingleSelectOptions(display) {
    if (!display)
        return [];
    if (display.text && Array.isArray(display.text.options))
        return display.text.options;
    if (display.radio && Array.isArray(display.radio.options))
        return display.radio.options;
    if (display.image && Array.isArray(display.image.options))
        return display.image.options;
    return [];
}
